import React from "react";

export const IconsComponentsEmail = ({ fill }) => {
  return (
    <svg
      width="29"
      height="22"
      viewBox="0 0 29 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.21834 0C1.52863 0 0.167969 1.55012 0.167969 3.37944V18.6109C0.167969 20.4499 1.52863 22 3.21834 22H25.5759C27.2656 22 28.6263 20.4402 28.6263 18.6109V3.37944C28.6263 1.54049 27.2656 0 25.5759 0H3.21834ZM3.36953 2.20485H25.4425L15.0019 12.9304C14.6195 13.3251 14.2015 13.3251 13.8191 12.9304L3.36953 2.20485ZM2.20452 4.03413L9.13234 11.1396L2.20452 18.6109V4.03413ZM26.5897 4.03413V18.6109L19.6886 11.13L26.5897 4.03413ZM18.2301 12.6416L24.8289 19.8048H3.98316L10.5997 12.6512L12.4228 14.519C13.5256 15.6551 15.3042 15.6551 16.407 14.519C16.3981 14.5287 18.2301 12.6416 18.2301 12.6416Z"
        fill={fill}
      />
    </svg>
  );
};
